import Vue from 'vue'
import buildVuexLogger from 'vuex/dist/logger'
import TempLocalStorage from './temp-local-storage'
import MockOrderApiClient from './order-api/mock-order-api-client'
import Bottle from 'bottlejs/dist/bottle'
import OrderApiClient from './order-api/order-api-client'
import buildStore from './store'
import VuexPersistence from 'vuex-persist'
import buildRoutes from './routes'
import buildRouter from './plugins/vue-router'
import UserApiClient from './user-api/user-api-client'
import MockUserApiClient from './user-api/mock-user-api-client'
import ProductsApiClient from './products-api/products-api-client'
import MockProductsApiClient from './products-api/mock-products-api-client'
import VueLogger from 'vuejs-logger'
import SubscriptionManager from './subscription/subscription-manager'
import StoreTokenProvider from './token/store-token-provider'
import SessionIdStorage from './service/session-id-storage'

export default function buildContainer (config) {
  const bottle = new Bottle()

  bottle.factory('config', () => config)

  bottle.factory('log', ({ config }) => {
    const options = {
      logLevel: config.env === 'dev' ? 'debug' : 'fatal',
      showLogLevel: true,
      showConsoleColors: true
    }
    // this *should* not be done here, but logger.initLoggerInstance is not exported, only the install function
    Vue.use(VueLogger, options)

    return Vue.$log
  })
  bottle.factory('vuexLogger', buildVuexLogger)
  bottle.factory(
    'vuexSession',
    ({ config, storeStorage }) => new VuexPersistence({
      strictMode: config.env !== 'production',
      storage: storeStorage
    })
  )
  bottle.factory(
    'store',
    ({ config, vuexSession, vuexLogger }) => buildStore(vuexSession, config.enableVuexLog ? vuexLogger : null)
  )
  bottle.factory(
    'tokenProvider',
    ({ store }) => new StoreTokenProvider(store)
  )
  bottle.factory(
    'sessionIdStorage',
    ({ store }) => new SessionIdStorage(store)
  )
  bottle.factory(
    'orderApiClient',
    ({ config, tokenProvider, sessionIdStorage }) => config.useMockOrderApiClient ? new MockOrderApiClient() : new OrderApiClient(config.orderApiUrl, tokenProvider, sessionIdStorage)
  )
  bottle.factory(
    'userApiClient',
    ({ config, sessionIdStorage, tokenProvider }) => config.useMockUserApiClient ? new MockUserApiClient() : new UserApiClient(config.userApiUrl, sessionIdStorage, tokenProvider)
  )
  bottle.factory('productsApiClient',
    ({ config, sessionIdStorage }) => config.useMockProductApiClient ? new MockProductsApiClient() : new ProductsApiClient(config.productApiUrl, sessionIdStorage))
  bottle.factory(
    'storeStorage',
    ({ config, log }) => new TempLocalStorage(window.localStorage, config.sessionTimeoutInMs, log)
  )
  bottle.factory('routes', async ({ store, subscriptionManager }) => buildRoutes(store, subscriptionManager))
  bottle.factory('router', async ({ routes }) => buildRouter(await routes))
  bottle.factory('subscriptionManager', ({ orderApiClient }) => new SubscriptionManager(orderApiClient))

  return bottle.container
}



// WEBPACK FOOTER //
// ./src/service.js